<template>
  <HLCardLayout disablePadding> <!-- :background="theme.espotoYellow"-->
    <template #title><span class="black--white">{{labelInfo}}</span></template>
    <template #menuTitle><h3 class="three-dots grey--text text--darken-3" :style="{'color': theme.textColor + '!important'}">{{eventTitle}}</h3></template>
    <template #content>
      <div class="text-sm-h6 pt-4 px-4" :style="{'color':theme.textColor}" v-html="eventDescr"/>
    </template>
  </HLCardLayout>
</template>

<script>
import HLCardLayout from '@/components/dashboard/HLCardLayout.vue'
import {layoutMixin} from '@/utils/layout-mixin'
import {eventMixin} from '@/utils/event-mixin'
import Utils from "../../store/modules/base";
import {spotMixin} from "../../utils/spot-mixin";
export default {
  mixins: [layoutMixin,eventMixin,spotMixin],
  components:{
    HLCardLayout
  },
  data(){
    return {
    }
  },
  computed: {
    eventDescr(){
      return Utils.replaceKeywords((this.selectedEvent)?this.selectedEvent.evcommentdt:'', this.getOfflineStatistic, this.allSpots, this.keywordExtras)
    },
    eventTitle(){
      return (this.selectedEvent)?this.selectedEvent.evnamedt:'';
    },
  },
  methods: {

  }
}
</script>
